import { BaseTitolo } from '@lucan/base-ui'

export default function Titolo(props) {
  const { children, ...rest } = props
  
  return <BaseTitolo variant="h2" {...rest}>{children}</BaseTitolo>
}
